const learnData = [
    {
        id: 'first-lesson',
        title: '1. Getting started with Scrawl-canvas',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Import the library into a web page and build a responsive ~Hello world~ canvas.',
        publishdate: "2024-04-26",
    }, 
    {
        id: 'second-lesson',
        title: '2. Using images with Scrawl-canvas',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Add responsive images to the canvas.',
        publishdate: "2024-04-26",
    }, 
    {
        id: 'third-lesson',
        title: '3. Build the Tower of Hanoi game',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Position entitys by reference to other entitys, and drag-and-drop them across the canvas.',
        publishdate: "2024-04-26",
    }, 
    {
        id: 'fourth-lesson',
        title: '4. Fun with ... videos',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Part one of a 3-part build: display and manipulate a video asset in a canvas display.',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'fifth-lesson',
        title: '5. Fun with ... filters and links',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Part two of a 3-part build: using graphic filters, and adding an external link to the canvas.',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'sixth-lesson',
        title: '6. Fun with ... tickers and tweens',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Part three of a 3-part build: use a timeline to keep canvas animations and video playback in sync.',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'seventh-lesson',
        title: '7. Build an image magnifier effect',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Use canvas compositing operations to combine two images into a display',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'eighth-lesson',
        title: '8. The kaleidoscope clock',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Working with canvas cells',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'ninth-lesson',
        title: '9. Modularized code',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Modularize Scrawl-canvas code to make it more reusable',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'tenth-lesson',
        title: '10. Fun with text',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Investigate the power of the EnhancedLabel entity',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'eleventh-lesson',
        title: '11. Accessible canvases',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'How to start and stop an animation; and respecting user preferences',
        publishdate: "2024-04-27",
    }, 
    {
        id: 'twelfth-lesson',
        title: '12. All the World\'s a Stage - gradients and patterns',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'Gradients and patterns, animating text along a path, displacement filters',
        publishdate: "2024-04-27",
    }, 
];

export default learnData;
